import { Component, OnInit } from '@angular/core';
import { SocioService } from '../../services/socio.service';
import { Socio } from '../../model/socio';
import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';

@Component({
  selector: 'app-socio-list',
  templateUrl: './socio-list.component.html',
  styleUrls: ['./socio-list.component.css']
})
export class SocioListComponent implements OnInit {

  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];

  public socios: Socio[];
  public socioSeleccionado: Socio;
  public query: any;
  public tipo: any;
public filtro:string;
  constructor(
    private _consorcioService: ConsorciosService,
    private _socioService: SocioService
  ) { }

  ngOnInit() {
    this.filtro = "";
    this.socios = [];
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.consorcio = null;
    this.tipo = null;
    this.socioSeleccionado = new Socio();
    this.cargarConsorcios();

  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });
  }

  cargarSocios() {
    if (this.consorcio === null) {
      return;
    }
    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      tipo: this.tipo !== "null" ? this.tipo : null
    };

    this._socioService.getSocios(this.query)
      .subscribe(
      data => this.socios = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  agregarRegistro() {
    if (this.consorcio === undefined) {
      return;
    }
    this.socioSeleccionado = new Socio();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarSocios();
  }


  editarRegistro(socio: Socio) {
    this.socioSeleccionado = socio;
    this.modoEdicion = true;
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/socio-list/socio-list.component.ts